import React from 'react';
import { breakpoints } from '../../const';

class NavMenu extends React.Component {
  state = {
    isMobile: true,
    isOpen: false
  };

  render() {
    const { Component, isLoggedIn, logout, clientStyleVariation } = this.props;
    return (
      <div className="nav__menu">
        {!this.state.isMobile && Component ? (
          <Component isLoggedIn={isLoggedIn} logout={logout} clientStyleVariation={clientStyleVariation} />
        ) : (
          this.renderMenu()
        )}
      </div>
    );
  }

  renderMenu() {
    const { Component, isLoggedIn, logout } = this.props;
    const classes = ['nav-menu'];
    if (this.state.isOpen) classes.push('nav-menu--open');

    return (
      <div className={classes.join(' ')} onClick={this.toggleMenu}>
        <p className="a--blue nav-menu-list-item">
          {!this.state.isOpen ? 'Menu' : 'Close'}
        </p>
        <div className="nav-menu-mobile">
          <Component isLoggedIn={isLoggedIn} logout={logout} />
        </div>
      </div>
    );
  }

  toggleMenu = e => this.setState({ isOpen: !this.state.isOpen });

  componentWillReceiveProps(nextProps, prevState) {
    const isMobile = nextProps.windowWidth < breakpoints.tablet;
    if (this.state.isMobile !== isMobile) {
      this.setState({ isMobile, isOpen: false });
    }
  }
}
export default NavMenu;



// WEBPACK FOOTER //
// ./src/components/nav/NavMenu.js